<mat-horizontal-stepper #stepper [linear]="isLinear">
  <mat-step [stepControl]="firstFormGroup">
    <form [formGroup]="firstFormGroup">
      <ng-template matStepLabel>
        <div>
          <span active>Delete Cascade</span>
        </div>
      </ng-template>
      <div class="mt-3 flex-gap-15px flex-row">
        <div class="flex-50">
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>Cascade Path</mat-card-title>
              <mat-card-subtitle class="sub-title">
                <h6>Select menu path below to apply item updates</h6>
                <mat-icon class="icon-help"
                  fontIcon="help_outline"
                  matTooltip="Find selected parent from anywhere on selected submenus">
                </mat-icon>
              </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content class="ml-3 left-card">
              <div class="filter-grp-wrapper">
                <mat-form-field class="filter-grp">
                  <mat-label>Filter</mat-label>
                  <input matInput [(ngModel)]="filterValue" [ngModelOptions]="{standalone: true}"
                    (input)="onFilterChange($event)"/>
                  <div class="filter-size" [matBadge]="filterSize" matBadgePosition="after"
                  matBadgeColor="warn"></div>
                  <button mat-icon-button class="close-btn" (click)="clearFilter()">
                    <mat-icon class="close-icon">close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              <mat-list class="path-list">
                @for (submenu of submenus; track submenu) {
                  <mat-list-item style="height: 40px;"
                    class="flex-column">
                    <mat-checkbox
                      [checked]="currentSubmenu === submenu.id || submenu.checked"
                      [disabled]="currentSubmenu === submenu.id"
                      (change)="updateAllSelected($event.checked, submenu.id)">
                      {{ submenu.name }}&nbsp;-&nbsp;{{ submenu.id }}
                    </mat-checkbox>
                  </mat-list-item>
                }
              </mat-list>
              <div>
                <h6>Select parent ancestors to apply</h6>
                <mat-chip-listbox aria-label="Parents Path">
                  @for (chip of bottomChips$ | async; track chip) {
                    <div class="flex-row">
                      <mat-icon class="mt-1">expand_more</mat-icon>
                      <mat-chip-option
                        [selected]="chip.selected"
                        [matTooltip]="chip.tag"
                        matTooltipPosition="right"
                        [ngClass]="chip.selected ? 'chip-selected': 'chip-deselected'"
                        (click)="toggleSelectBottomChip(chip)"
                        >{{ chip.name }}
                      </mat-chip-option>
                    </div>
                  }
                </mat-chip-listbox>
                <div class="status">
                  @if (spinner$ | async) {
                    <mat-progress-spinner
                      [color]="color"
                      [diameter]="diameter"
                      [mode]="mode"
                      >
                    </mat-progress-spinner>
                  }
                  @if (!(spinner$ | async)) {
                    <div class="flex-row">
                      <div><strong>Found {{ matchCount$ | async }} matches for path</strong></div>
                      <div>
                        <mat-icon class="info" (click)="togglePath()"> info</mat-icon>
                      </div>
                    </div>
                  }
                </div>
                @if (showPath$ | async) {
                  <div><code>{{ parentDeletePath }}</code></div>
                }
              </div>

            </mat-card-content>
          </mat-card>
        </div>
        <div class="flex-50">
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>Item Updates</mat-card-title>
              <mat-card-subtitle>
                The following item will be removed from the selected path in all selected submenus for this
                menu.
              </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content class="ml-3">
              <div class="flex-column">
                <br>
                  @for (item of bottomChips$ | async; track item) {
                    <div>
                      <div class="flex-row">
                        <div class="flex-40">
                          <label>{{ item.name | camelCaseToSentenceCase }}</label>
                        </div>
                        @if (item.tag !== null) {
                          <div class="flex-offset-3 flex-60">
                            {{ item.tag }}
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <br/>
        <div class="status">
          @if (spinner$ | async) {
            <mat-progress-spinner
              [color]="color"
              [diameter]="diameter"
              [mode]="mode"
              >
            </mat-progress-spinner>
          }
          @if (!(spinner$ | async)) {
            <div>
              <h6>Found {{ parentCount$ | async }} matches for parent</h6>
            </div>
          }
        </div>
        <div class="buttons flex-center-center">
          <button
            [attr.data-testid]="'cancel_button'"
            class="button-color"
            mat-raised-button
            matTooltip="Cancel"
            (click)="onNoClick()"
            >Cancel
          </button>
          <button
            [attr.data-testid]="'continue_button'"
            class="button-color"
            mat-raised-button
            matTooltip="Continue"
            matStepperNext
            (click)="onSelect($event)"
            >Continue
          </button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <div>
        <ng-template matStepLabel>Confirm Delete</ng-template>
        <div>
          <br>
            <h6>Are you sure you want to delete cascade all {{ matchCount$ | async }} matches of item path</h6>
            <h5 class="item-bold">{{ parent.data.data.name }} ({{ parent.data.data.tag }})</h5>
            <h6>from under @if (subMenuOnly.value === true) {
              <span>sub-menu only?</span>
            } @else {
              @if (featureScope === 'Legacy') {
                <span>anywhere on this menu?</span>
              } @else {
                <span>across these submenus?</span><!-- Rename wording when multiple submenus supported -->
              }
            }
          </h6>
        </div>
        <div class="buttons flex-center-center">
          <button
            [attr.data-testid]="'cancel_button'"
            class="button-color"
            mat-raised-button
            matTooltip="Cancel"
            (click)="onNoClick()"
            >Cancel
          </button>
          <button
            [attr.data-testid]="'back_button'"
            class="button-color"
            mat-raised-button
            matStepperPrevious
            matTooltip="Back"
            >Back
          </button>
          <button
            [attr.data-testid]="'yes_button'"
            cdkFocusInitial
            class="button-color"
            mat-raised-button
            matTooltip="Delete"
            (click)="onSave()"
            >Yes
          </button>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
